module.exports = __webpack_public_path__ + "img/lionking.83273525.png";